import type { SearchPayload } from '@creator/sdk/modules/search';
import type { CommentSearchResult, PostSearchResult, TokenSearchResult, UserSearchResult } from '@creator/sdk/modules/search/search.model';
import creatorSdk from '@src/services/creator-sdk';

export async function searchPosts(payload: SearchPayload): Promise<PostSearchResult> {
    return creatorSdk.searchModule.searchPosts(payload);
}

export async function searchComments(payload: SearchPayload): Promise<CommentSearchResult> {
    return creatorSdk.searchModule.searchComments(payload);
}

export async function searchUsers(payload: SearchPayload): Promise<UserSearchResult> {
    return creatorSdk.searchModule.searchUsers(payload);
}

export async function searchTokens(payload: SearchPayload): Promise<TokenSearchResult> {
    return creatorSdk.searchModule.searchTokens(payload);
}
